import React, { useEffect, useState, useRef } from 'react';
import * as Styles from './styles';
import { Badge } from '../../../Badge';
import { calculateInnerElements } from '../../utils/calculateInnerElements';
import { getInnerElementsSizes } from '../../utils/getInnerElementsSizes';
export const Badges = _ref => {
  let {
    children,
    width,
    headBadge
  } = _ref;
  const totalBadges = ((children === null || children === void 0 ? void 0 : children.length) || 0) + (headBadge ? 1 : 0);
  const [loading, setLoading] = useState(true);
  const badgeGroupRef = useRef(null);
  const [numberOfVisibleBadges, setNumberOfVisibleBadges] = useState(totalBadges);
  const [badgesSizes, setBadgesSizes] = useState([]);
  const visibleBadges = numberOfVisibleBadges - 1;
  const hiddenBadges = totalBadges - numberOfVisibleBadges;
  useEffect(() => {
    setBadgesSizes(getInnerElementsSizes(badgeGroupRef));
  }, []);
  useEffect(() => {
    const moreOneWidth = 40;
    setNumberOfVisibleBadges(calculateInnerElements(badgesSizes, badgeGroupRef, moreOneWidth));
  }, [badgesSizes, width]);
  useEffect(() => {
    setLoading(false);
  }, []);
  if (!children && !headBadge) {
    return React.createElement("div", {
      style: {
        height: '23px'
      }
    });
  }
  const shouldInformAboutHiddenBadges = totalBadges > 0 && !!hiddenBadges && hiddenBadges !== totalBadges && !loading;
  return React.createElement(Styles.BadgeGroup, {
    ref: badgeGroupRef,
    className: loading ? 'loading' : '',
    "data-testid": "badgeGroup"
  }, headBadge && React.createElement(Styles.BadgeItem, null, headBadge), children === null || children === void 0 ? void 0 : children.map((badge, idx) => {
    const realIndex = idx + (headBadge ? 1 : 0);
    const visible = realIndex <= visibleBadges;
    if (!visible) return null;
    if (typeof badge === 'string') {
      return React.createElement(Styles.BadgeItem, {
        key: badge,
        "data-testid": "default-badge-item"
      }, React.createElement(Badge, {
        "aria-label": badge
      }, badge));
    }
    return React.createElement(Styles.BadgeItem, {
      "data-testid": "custom-badge-item",
      key: idx
    }, badge);
  }), shouldInformAboutHiddenBadges && React.createElement(Styles.BadgeItem, null, React.createElement(Badge, {
    "aria-label": "Mais de 1 item"
  }, "+", hiddenBadges)));
};